import React, { useState } from 'react';
import { Container, Button } from 'react-bootstrap';
import SettingsTable from '../../../../components/tables/SettingsTable';
import OperatorsModal from '../../../../components/modals/OperatorsModal';

const Operators = () => {
  // Sample data generator
  const generateSampleData = (count = 35) => {
    const operators = [
      'Airtel', 'Jio', 'VI', 'BSNL', 'MTNL',
      'Airtel DTH', 'Tata Sky', 'Dish TV', 'Sun Direct', 'd2h',
      'Reliance Gas', 'Indane Gas', 'HP Gas', 'Bharat Gas',
      'BSES', 'Tata Power', 'Adani Power', 'Torrent Power'
    ];
    const services = ['Mobile Recharge', 'DTH Recharge', 'Gas Booking', 'Bill Payment', 'Broadband'];
    const logos = [
      'https://via.placeholder.com/50x30?text=Airtel',
      'https://via.placeholder.com/50x30?text=Jio',
      'https://via.placeholder.com/50x30?text=VI',
      'https://via.placeholder.com/50x30?text=BSNL'
    ];
    
    return Array.from({ length: count }, (_, i) => ({
      operatorName: operators[i % operators.length],
      opCode: `OP${String(i + 1).padStart(3, '0')}`,
      serviceName: services[Math.floor(Math.random() * services.length)],
      status: Math.random() > 0.3 ? 'Active' : 'Inactive',
      logo: logos[i % logos.length],
      inputFields: Math.floor(Math.random() * 5) + 1
    }));
  };

  const [data, setData] = useState(generateSampleData(35));
  const [showModal, setShowModal] = useState(false);
  const [modalMode, setModalMode] = useState('add');
  const [selectedOperator, setSelectedOperator] = useState(null);

  const handleAddOperator = () => {
    setModalMode('add');
    setSelectedOperator(null);
    setShowModal(true);
  };

  const handleEditOperator = (operator) => {
    setModalMode('edit');
    setSelectedOperator(operator);
    setShowModal(true);
  };

  const handleSaveOperator = (operatorData) => {
    if (modalMode === 'add') {
      setData([...data, operatorData]);
    } else {
      setData(data.map(item => 
        item.operatorName === selectedOperator.operatorName && item.opCode === selectedOperator.opCode
          ? { ...item, ...operatorData }
          : item
      ));
    }
  };

  // Column definitions
  const columns = [
    {
      key: 'actions',
      label: 'Actions',
      render: (row) => (
        <div className="d-flex gap-1 justify-content-center">
          <Button 
            size="sm" 
            className="btn-outline-primary-custom"
            title="Edit"
            style={{
              padding: '0.25rem 0.5rem'
            }}
            onClick={() => handleEditOperator(row)}
          >
            <i className="bi bi-pencil"></i>
          </Button>
        </div>
      )
    },
    { key: 'operatorName', label: 'Operator Name' },
    { key: 'opCode', label: '24Pay Op Code' },
    { key: 'serviceName', label: 'Service Name' },
    { key: 'status', label: 'Operator Active/Inactive Status' },
    { 
      key: 'logo', 
      label: 'Operator Logo',
      render: (row) => (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <div 
            style={{ 
              width: '60px', 
              height: '35px', 
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              border: '2px solid #e5e7eb',
              borderRadius: '6px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '0.65rem',
              color: 'white',
              fontWeight: '700',
              textTransform: 'uppercase',
              letterSpacing: '0.5px',
              boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
            }}
          >
            {row.operatorName.substring(0, 4)}
          </div>
        </div>
      )
    },
    { key: 'inputFields', label: 'Input Fields' }
  ];

  return (
    <Container fluid className="p-4">
      <SettingsTable
        data={data}
        settingsType="Operators"
        columns={columns}
        onAdd={handleAddOperator}
      />
      <OperatorsModal
        show={showModal}
        handleClose={() => setShowModal(false)}
        mode={modalMode}
        operatorData={selectedOperator}
        onSave={handleSaveOperator}
      />
    </Container>
  );
};

export default Operators;

